
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/closed-cases",
      function () {
        return require("private-next-pages/closed-cases.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/closed-cases"])
      });
    }
  